import { useMemo, useCallback } from "react";
import {
  getServiceablePincodesSet,
  getRadiusConfig,
  getBoundaryConfig,
  isAddressServiceable as isAddressServiceableFn,
} from "../utils/hubServiceableUtils";

/**
 * Hub serviceable-area hook. Use in AddAddress and CartPage.
 * @param {object|null} selectedInventory - Current hub inventory (from Redux / getHubInventory)
 * @returns {{
 *   serviceablePincodes: Set,
 *   radiusConfig: Array<{ lat, lng, radiusKm }>,
 *   boundaryConfig: Array<Array<{ lat, lng }>>,
 *   isAddressServiceable: (addr: { latitude?, longitude?, pin? }) => boolean
 * }}
 */
export function useHubServiceable(selectedInventory) {
  const serviceablePincodes = useMemo(
    () => getServiceablePincodesSet(selectedInventory),
    [selectedInventory]
  );

  const radiusConfig = useMemo(
    () => getRadiusConfig(selectedInventory),
    [selectedInventory]
  );

  const boundaryConfig = useMemo(
    () => getBoundaryConfig(selectedInventory),
    [selectedInventory]
  );

  const config = useMemo(
    () => ({
      serviceablePincodes,
      radiusConfig,
      boundaryConfig,
    }),
    [serviceablePincodes, radiusConfig, boundaryConfig]
  );

  const isAddressServiceable = useCallback(
    (addr) => isAddressServiceableFn(addr, selectedInventory, config),
    [selectedInventory, config]
  );

  return {
    serviceablePincodes,
    radiusConfig,
    boundaryConfig,
    isAddressServiceable,
  };
}
